export default class Component {
    $target;
    $props;
    $state;

    constructor($target, $props) {
        this.$target = $target;
        this.$props = $props; // $props 할당
        this.setup();
        this.render();
        this.setEvent();
    }

    setup() {
    };

    mounted() {
    };

    template() {
        return '';
    }

    render() {
        this.$target.innerHTML = this.template();
        this.mounted();
    }

    setEvent() {
    }

    setState = (newState) =>{
        this.$state = {...this.$state, ...newState};
    }

    addEvent(eventType, selector, callback) {
        if(typeof selector === 'function'){
            callback = selector;
            selector = null;
        }

        const children = [...this.$target.querySelectorAll(selector)];
        const isTarget = (target) => children.includes(target) || target.closest(selector);
        this.$target.addEventListener(eventType, event => {
            if (selector && !isTarget(event.target)) return false;
            callback(event);
        })
    }
}
